<template>
  <div class="modal post-modal" tabindex="-1" id="modal">
    <post></post>
  </div>
</template>

<script lang="js">
/* global $ */
import postModalComponent from './post-modal/PostModal.vue';

export default {
  components: {
    post: postModalComponent,
  },

  mounted() {
    const $modal = $(this.$el);

    $modal.on('hidden.bs.modal', () => {
      this.$store.dispatch('clearModalPost');
    });
  },
};
</script>
